// extracted by mini-css-extract-plugin
export default {"widget":"SoundCloudWidget_widget__q1Jnz","slideIn":"SoundCloudWidget_slideIn__vR+qv","closeButton":"SoundCloudWidget_closeButton__gRNYs"};